import { Form } from 'react-bootstrap';
import ScriptEditor from '../ui/ScriptEditor';

const Bash = ({ state, onChange, readOnly = false }) => {
  const { script, run_as_user, nr_of_lines_to_load } = state.config || {};

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-run_as_user">
        <Form.Label>Run as user</Form.Label>
        <Form.Control type="text" name="run_as_user" value={run_as_user || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-nr_of_lines_to_load">
        <Form.Label>Number of lines to load</Form.Label>
        <Form.Control type="text" name="nr_of_lines_to_load" value={nr_of_lines_to_load || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <ScriptEditor
        label="Script"
        controlId="formNode-script"
        name="script"
        value={script || ''}
        language="shell"
        onChange={(e) => onChange(e, true)}
        readOnly={readOnly}
        aria-label="Script editor"
      />
    </>
  );
};

export default Bash;
